import { create } from 'zustand';
import { registerReset } from './resetStores';
export var useSnackbarStore = create(function (set) { return ({
    open: false,
    type: 'info',
    message: '',
    autoHideDuration: 3000,
    showSnackbar: function (type, message, autoHideDuration) {
        if (autoHideDuration === void 0) { autoHideDuration = 3000; }
        return set({ open: true, type: type, message: message, autoHideDuration: autoHideDuration });
    },
    closeSnackbar: function () { return set({ open: false }); },
    resetSnackbar: function () {
        return set({ open: false, type: 'info', message: '', autoHideDuration: 3000 });
    },
}); });
registerReset(function () {
    useSnackbarStore.getState().resetSnackbar();
}, "snackbar");
